<mat-sidenav-container class="sidenav-container">
  <mat-sidenav #drawer id="mat-sidenav" class="sidenav" fixedInViewport="true" [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
    [mode]="(isHandset$ | async) ? 'over' : 'side'" [opened]="!(isHandset$ | async)">
    <mat-toolbar color="primary">
      <div class="no-action" *ngIf="notVerify"></div>
      <a class="navbar-brand mr-auto" [routerLink]="['/partner/dashboard']">
        <img *imageWithBrandPrefix="'assets/images/Client_Portal_Logo.png'" align="center" class="navbar-brand-logo" alt="" />
      </a>
    </mat-toolbar>
    <mat-nav-list class="d-md-block d-none">
      <div class="no-action" *ngIf="notVerify"></div>
      <a mat-list-item routerLink="/partner/dashboard" routerLinkActive="active-link" *accessRoles="VIEW_DASHBOARD">
        <img src="assets/images/dashboard-icon/dashboard.png" align="center" alt="" />Dashboard
      </a>

      <a mat-list-item routerLink="/partner/search-referral" routerLinkActive="active-link">
        <img src="assets/images/dashboard-icon/search_referral.png" align="center" alt="" /> Search Referral</a>

      <a mat-list-item *accessRoles="VIEW_REPORT" (click)="showHideViewReport()">
        <img src="assets/images/dashboard-icon/view_reports.png" align="center" alt="" /> View Reports</a>

      <div class="sub-menu-payment" [hidden]="!viewReportState">
        <a mat-list-item routerLink="/partner/commission-report" class="pl-3" routerLinkActive="active-link">
          <img src="assets/images/dashboard-icon/query_manager.png" align="center" alt="" /> Commission Report
        </a>
      </div>
    </mat-nav-list>

    <mat-nav-list class="d-block d-md-none">
      <div class="no-action" *ngIf="notVerify"></div>
      <a mat-list-item routerLink="/partner/dashboard" routerLinkActive="active-link" (click)="drawer.toggle()" *accessRoles="VIEW_DASHBOARD">
        <img src="assets/images/dashboard-icon/dashboard.png" align="center" alt="" /> Dashboard
      </a>

      <a *accessRoles="SEND_REFERRAL" mat-list-item routerLink="/partner/referral" routerLinkActive="active-link" [ngClass]="!showHideSubMenu ? 'active-link' : ''"
        (click)="drawer.toggle()">
        <img src="assets/images/dashboard-icon/send_referral.png" align="center" alt="" /> Send Referral</a>

      <a mat-list-item routerLink="/partner/search-referral" routerLinkActive="active-link" (click)="drawer.toggle()">
        <img src="assets/images/dashboard-icon/search_referral.png" align="center" alt="" /> Search Referral</a>

      <a mat-list-item *accessRoles="VIEW_REPORT" (click)="showHideViewReport()">
        <img src="assets/images/dashboard-icon/view_reports.png" align="center" alt="" /> View Reports</a>

      <div class="sub-menu-payment" [hidden]="!viewReportState" (click)="drawer.toggle()">
        <a mat-list-item routerLink="/partner/commission-report" class="ml-4" routerLinkActive="active-link">
          <img src="assets/images/dashboard-icon/query_manager.png" align="center" alt="" /> Commission Report
        </a>
      </div>
    </mat-nav-list>

  </mat-sidenav>
  <mat-sidenav-content>
    <mat-toolbar color="primary">
      <button id="showHideNav" type="button" aria-label="Toggle sidenav" mat-icon-button (click)="drawer.toggle()">
        <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
      </button>
      <div class="d-none d-md-inline-block">
        <span class="nav-header text-fw-700">Partner Portal |&nbsp;</span>
        <span class="nav-header">{{ userInfo.accountName }}&nbsp;&nbsp;&nbsp;&nbsp;ID: {{ userInfo.accountNumber }}</span>
      </div>
      <div class="d-inline-block d-md-none">
        <span class="nav-header text-fw-700">Partner Portal |&nbsp;</span>
        <span class="nav-header">{{ userInfo.accountName }}...</span>
      </div>

      <div class="account-info-mobile--wrapper d-block d-md-none ml-auto">
        <img title="User Menu" class="img-user-menu target-click" *imageWithBrandPrefix="'/assets/images/icon-png/user.png'" (click)="showMenu()" alt=""
        />
        <ul #menu class="menu-user" [hidden]="showHideMenu">
          <li class="user-name">{{ userInfo.fullName }}</li>
          <li class="user-role" *ngIf="isPartnerAdmin" >{{ PARTNER_ADMIN }}</li>
          <li>
            <a class="navigation-link" routerLink="/partner/user-profile" [class.disabled]="notVerify" (click)="hideMenu()">Profile</a>
          </li>
          <li>
            <a class="navigation-link" (click)="hideMenu()" routerLink="/partner/change-memorable-number" [class.disabled]="notVerify">Change Memorable Number</a>
          </li>
          <li>
            <a class="navigation-link" (click)="hideMenu()" routerLink="/partner/change-password" [class.disabled]="notVerify">Change Password</a>
          </li>
          <li *accessRoles="MANAGE_USERS">
            <a class="navigation-link" routerLink="/partner/manage-user" [class.disabled]="notVerify" (click)="hideMenu()">User Management</a>
          </li>
          <li>
            <a class="navigation-link" (click)="logout()">Log out</a>
          </li>
        </ul>
      </div>

      <div class="menu-right d-none d-md-block">
        <ul class="main-dropdown-menu">
          <li>
            <img class="img-user-menu target-click" *imageWithBrandPrefix="'/assets/images/icon-png/user.png'" (click)="showMenu()" alt="" />
            <ul #menu class="menu-user" [hidden]="showHideMenu">
              <ul class="sub-menu-user">
                <li class="user-name">{{ userInfo.fullName }}</li>
                <li class="user-role" *ngIf="!!partnerAdmin" >{{ partnerAdmin.displayName }}</li>
              </ul>
              <li>
                <a class="navigation-link" (click)="hideMenu()" routerLink="/partner/user-profile" [class.disabled]="notVerify">Profile</a>
              </li>
              <li>
                <a class="navigation-link" (click)="hideMenu()" routerLink="/partner/change-memorable-number" [class.disabled]="notVerify">Change Memorable Number</a>
              </li>
              <li>
                <a class="navigation-link" (click)="hideMenu()" routerLink="/partner/change-password" [class.disabled]="notVerify">Change Password</a>
              </li>
              <li *accessRoles="MANAGE_USERS">
                <a class="navigation-link" (click)="hideMenu()" routerLink="/partner/manage-user" [class.disabled]="notVerify">User Management</a>
              </li>
              <li>
                <a class="navigation-link" (click)="logout()">Log out</a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </mat-toolbar>
    <ng-content></ng-content>
  </mat-sidenav-content>
</mat-sidenav-container>